import React from 'react';
import { BrainIcon, HeartIcon } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-20 bg-white" data-id="element-44">
      <div className="container mx-auto px-4" data-id="element-45">
        <div className="max-w-4xl mx-auto" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-purple-800" data-id="element-47">
            Prueba de Credibilidad
          </h2>
          <div className="bg-purple-50 p-8 rounded-2xl shadow-sm mb-12" data-id="element-48">
            <div className="flex flex-col md:flex-row gap-8" data-id="element-49">
              <div className="md:w-1/2" data-id="element-50">
                <div className="flex items-center mb-4" data-id="element-51">
                  <BrainIcon size={24} className="text-purple-600 mr-3" data-id="element-52" />
                  <h3 className="text-xl font-semibold text-purple-800" data-id="element-53">
                    Respaldo Científico
                  </h3>
                </div>
                <p className="text-gray-700" data-id="element-54">
                  La ciencia ha demostrado que los estados cerebrales Theta y
                  Delta son claves para la reprogramación profunda y la sanación
                  emocional.
                </p>
              </div>
              <div className="md:w-1/2" data-id="element-55">
                <div className="flex items-center mb-4" data-id="element-56">
                  <HeartIcon size={24} className="text-purple-600 mr-3" data-id="element-57" />
                  <h3 className="text-xl font-semibold text-purple-800" data-id="element-58">
                    Sabiduría Espiritual
                  </h3>
                </div>
                <p className="text-gray-700" data-id="element-59">
                  Maestros espirituales desde Jesús hasta los sabios de oriente
                  han repetido lo mismo: "El cielo está dentro de ti."
                </p>
              </div>
            </div>
            <div className="mt-8 text-center" data-id="element-60">
              <p className="text-purple-800 font-medium" data-id="element-61">
                Este reto une ambas verdades — la ciencia de las ondas
                cerebrales y la sabiduría espiritual — en un método práctico que
                cualquiera puede aplicar.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}